import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
	react: {
        useSuspense: false //   <---- this will do the magic
    },
    lng: null,
    fallbackLng: null,
    interpolation: {
      escapeValue: true
    }
  });

export default i18n;
